import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { CoreUiInteractionEvent, UiInteraction } from "@obg/ngx.core";
import { CoreContentState, Flag, FlagAction, FlagSelector } from "@obg/ngx.core.content";
import { ignoreEmpty, ignoreNil } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { TrackingContext } from "../tracking/tracking.model";

@Component({
	selector: "obg-language-selector",
	templateUrl: "./language-selector.container.html",
	styleUrls: ["./language-selector.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class LanguageSelectorContainer implements OnInit {
	currentFlag$: Observable<Flag> | undefined;
	flags$: Observable<Flag[]> | undefined;

	constructor(
		private store: Store<CoreContentState>,
		private flagAction: FlagAction
	) {}

	ngOnInit() {
		this.currentFlag$ = this.store.select(FlagSelector.getCurrentFlag).pipe(ignoreNil());
		this.flags$ = this.store.select(FlagSelector.getAll).pipe(ignoreEmpty());
	}

	languageClick(flag: Flag) {
		this.store.dispatch(this.flagAction.setCurrent(flag));
	}

	getLanguageItemPayload(flag?: Flag): UiInteraction {
		return {
			event: CoreUiInteractionEvent.Navigate,
			context: TrackingContext.LanguageSelectorInteractionContext,
			data: {
				ItemClicked: flag ? `Language - ${flag.languageCode}-${flag.countryCode}` : "Language",
			},
		};
	}

	flagTrackBy(_index: number, flag: Flag): string {
		return flag.id;
	}
}
